import flatten from 'lodash/flatten';
import { formatYear } from 'modules/utils/DateUtils';
import { ProviderSearchFilters, LocalFiltersObject, LocalFacetsObject, Educations } from './types';

export const createFilters = (): ProviderSearchFilters => ({
  filters: [],
  facets: []
});

export const mergeFiltersAndFacets = (
  filters: LocalFiltersObject,
  facets: LocalFacetsObject
): ProviderSearchFilters => {
  const dispatchSearchFilters: ProviderSearchFilters = createFilters();
  dispatchSearchFilters.filters = Object.entries(filters).map(filter => {
    return { group: filter[0], value: filter[1] };
  });
  dispatchSearchFilters.facets = flatten(Object.values(facets));
  return dispatchSearchFilters;
};

export const getProviderDegreeText = (item: Educations) => {
  const { institutionDesc, institutionCity, degreeDesc, startDate, endDate } = item;
  const institutionState = item.institutionState ? item.institutionState : '';
  const degreeDescription = degreeDesc ? `in ${degreeDesc},` : '';
  return `${institutionDesc} ${institutionCity}, ${institutionState} ${degreeDescription} ${formatYear(
    startDate
  )} - ${formatYear(endDate)}`;
};
